import { render } from "./PurchaseReturnList.vue?vue&type=template&id=af2b3a32"
import script from "./PurchaseReturnList.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__